// extracted by mini-css-extract-plugin
module.exports = {"page":"Overview_page__4dZVO"};